<template>
  <div>
    <data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      :fetch="fetch"
      :search="query"
      :server-items-length="
        pagingMetadata.totalCount ? pagingMetadata.totalCount : Infinity
      "
      :reset-search="resetSearch"
      item-key="id"
      :options="options"
      :update-options="updateOptions"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-end">
          <download-button :entity="item">
            <template v-slot:default="{ on, loading }">
              <v-btn
                class="mr-5"
                text
                icon
                :loading="loading"
                @click="downloadExport(item)"
              >
                <v-icon> mdi-file-table </v-icon>
              </v-btn>
            </template>
          </download-button>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import {
  FETCH,
  RESET_SEARCH,
  EXPORTS,
  ADD_SNACKBAR,
  HIDE_SNACKBAR
} from "@/store/action-types";
import { mapExportsSearchFormFields } from "@/store/modules/exports";
import DataTable from "@/components/functional/DataTable";
import DownloadButton from "@/components/exports/DownloadButton";

import VuePapaParse from "vue-papa-parse";
import Vue from "vue";
Vue.use(VuePapaParse);

const {
  mapActions: mapExportsActions,
  mapState: mapExportsState
} = createNamespacedHelpers(`exports`);

const { mapActions: mapExportsSearchFormActions } = createNamespacedHelpers(
  `exports/searchForm`
);

const { mapActions: mapAppActions } = createNamespacedHelpers(`app`);

export default {
  components: {
    DataTable,
    DownloadButton
  },
  data() {
    return {
      selected: [],
      headers: [
        { text: "Application", value: "application.nom" },
        { text: "Export", value: "nom" },
        { text: "", value: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapExportsState(["list", "pagingMetadata"]),
    ...mapExportsState({
      entityLoading: "loading"
    }),
    ...mapExportsSearchFormFields(["query", "options"]),
    ...mapExportsSearchFormFields({
      entitySearchLoading: "loading"
    }),
    loading() {
      return this.entityLoading || this.entitySearchLoading;
    }
  },
  methods: {
    ...mapExportsActions({
      fetch: FETCH,
      exports: EXPORTS
    }),
    ...mapExportsSearchFormActions({
      resetSearch: RESET_SEARCH
    }),
    ...mapAppActions({
      addSnackbar: ADD_SNACKBAR,
      hideSnackbar: HIDE_SNACKBAR
    }),
    updateOptions(newOptions) {
      this.options = newOptions;
    },
    download(csv, title) {
      try {
        const data = new TextEncoder("windows-1252", {
          NONSTANDARD_allowLegacyEncoding: true
        }).encode(csv); // now `data` is an Uint8Array

        let csvData = new Blob([data], { type: "text/csv" });
        let csvUrl = URL.createObjectURL(csvData);

        let link = document.createElement("a");
        link.id =
          "csv-" +
          parseInt(
            Math.random()
              .toString()
              .slice(2, 16)
          );
        link.href = csvUrl;

        document.body.appendChild(link);

        let $el = document.getElementById(link.id);

        $el.style.visibility = "hidden";
        $el.download = title + ".csv";
        $el.click();

        setTimeout(function() {
          document.body.removeChild(link);
        });

        return true;
      } catch (err) {
        return false;
      }
    },
    downloadExport(item) {
      this.addSnackbar({
        message: this.$t("Téléchargement en cours..."),
        timeout: 60000,
        type: "info"
      });

      this.exports({ item }).then(res => {
        // get export data in res.list
        var data = res.list;
        // unparse json to csv
        var csv = this.$papa.unparse(data, {
          delimiter: ";",
          quotes: true
        });
        //set filename
        var today = new Date().toISOString().substring(0, 10);
        var name = item.nom.concat("_", today);
        //do download
        this.download(csv, name); //use loacl method
        //this.$papa.download(csv, name); //use papa download

        // hide snackbar
        this.hideSnackbar({});
        // display download is finished
        this.addSnackbar({
          message: this.$t("Téléchargement terminé!"),
          timeout: 6000,
          type: "success"
        });
      });
    }
  }
};
</script>
